import { useTranslation } from 'react-i18next'

import { PackageIcon } from '@phosphor-icons/react'

import { Checkbox, Text } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const CarrierWithShippings = ({ carrier, checked, onCheck }) => {
  const { t } = useTranslation()

  return (
    <Styles.Container>
      <Checkbox
        label={
          <Styles.CarrierLabelContainer>
            {carrier?.logo_url && <img src={carrier?.logo_url} alt={carrier?.name} />}
            <Text type="titleS">{carrier?.name}</Text>
          </Styles.CarrierLabelContainer>
        }
        checked={checked}
        onChange={() => onCheck(carrier?.id)}
      />
      <Styles.ShipmentCount>
        <PackageIcon size={20} />
        <Text type="bodyMRegular">
          {carrier?.shipment_count} {carrier?.shipment_count > 1 ? t('envíos') : t('envío')}
        </Text>
      </Styles.ShipmentCount>
    </Styles.Container>
  )
}

export default CarrierWithShippings
